export const isNumber = (value: any) : boolean => typeof value === 'number' && !isNaN(value);
